import React from 'react';

import phoneIcon from 'assets/pics/combined-shape.png';
import PropTypes from 'prop-types';

import { SectionTitle } from 'components/FormHelper/SectionTitle';
import { EmailIcon } from 'components/Icons/EmailIcon';

import './ContactResultItem.scss';

export const ContactResultItem = ({
  title,
  phone,
  onSendMessageClick,
  email,
  contactWorkTitle,
}) => {
  const renderSendMessage = () => {
    if (!onSendMessageClick && !email) {
      return null;
    }

    if (onSendMessageClick) {
      return (
        <button type="button" className="email-modal-open" onClick={onSendMessageClick}>
          <EmailIcon />
          <div className="icon-label">Nachricht senden</div>
        </button>
      );
    }

    return (
      <a className="email-modal-open" href={`mailto:${email}`}>
        <EmailIcon />
        <div className="icon-label">Nachricht senden</div>
      </a>
    );
  };

  return (
    <div className="expert-container">
      <div className="headline-container">
        <SectionTitle>{title}</SectionTitle>
        {contactWorkTitle && <div className="contact-work-title">{contactWorkTitle}</div>}
      </div>
      <div className="numbers-container">
        {phone && (
          <>
            {Array.isArray(phone) ? (
              phone.map((phoneNumber) => (
                <div key={phoneNumber} className="phone-number">
                  <h6>
                    <img alt="" src={phoneIcon} className="phone-icon" />
                    <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                  </h6>
                </div>
              ))
            ) : (
              <div className="phone-number">
                <h6>
                  <img alt="" src={phoneIcon} className="phone-icon" />
                  <a href={`tel:${phone}`}>{phone}</a>
                </h6>
              </div>
            )}
            <span className="notice">Während der üblichen Geschäftszeiten</span>
          </>
        )}
        {renderSendMessage()}
      </div>
    </div>
  );
};

ContactResultItem.propTypes = {
  title: PropTypes.string.isRequired,
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  onSendMessageClick: PropTypes.func,
  email: PropTypes.string,
  contactWorkTitle: PropTypes.string,
};

ContactResultItem.defaultProps = {
  onSendMessageClick: null,
  phone: null,
  email: null,
  contactWorkTitle: null,
};
